import React from 'react'
import { Carousel } from 'react-bootstrap'

function CarousalComponent() {
    return (
        <>
            <Carousel fade>
                <Carousel.Item interval={1000}>
                    <img className='home-caurosal-images' src="/images/caurosal1.jpg" />
                    <Carousel.Caption>
                        <h3>Non Veg Pizza</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item interval={1000}>
                    <img className='home-caurosal-images' src="/images/caurosal2.jpg" />
                    <Carousel.Caption>
                        <h3>Spicy Pizza</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img className='home-caurosal-images' src="/images/caurosal3.jpg" />
                    <Carousel.Caption>
                        <h3>Chicken Combo Pack</h3>
                        <p>
                            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
                        </p>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        </>
    )
}

export default CarousalComponent